import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function getMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function createSession(session_id) {
  const { data } = await api.post("/auth/session", { session_id });
  return data;
}

export async function jwtLogin(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function jwtRegister(email, password, name) {
  const { data } = await api.post("/auth/register", { email, password, name });
  return data;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function setFounderType(founder_type) {
  const { data } = await api.post("/auth/founder-type", { founder_type });
  return data;
}

export async function getUsageLimits() {
  const { data } = await api.get("/usage/limits");
  return data;
}

export async function listIdeas() {
  const { data } = await api.get("/ideas");
  return data;
}

export async function dashboardSummary() {
  const { data } = await api.get("/dashboard/summary");
  return data;
}

export async function createIdea(payload) {
  const { data } = await api.post("/ideas", payload);
  return data;
}

export async function getIdea(idea_id) {
  const { data } = await api.get(`/ideas/${idea_id}`);
  return data;
}

export async function diagnose(idea_id) {
  const { data } = await api.post(`/ideas/${idea_id}/diagnose`);
  return data; // { job_id, status }
}

export async function getDiagnosisJob(idea_id, job_id) {
  const { data } = await api.get(`/ideas/${idea_id}/diagnose/jobs/${job_id}`);
  return data;
}

export async function waitForDiagnosis(
  idea_id,
  job_id,
  { intervalMs = 3000, timeoutMs = 300000 } = {},
) {
  const started = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const s = await getDiagnosisJob(idea_id, job_id);
    if (s.status === "done") return s;
    if (s.status === "error") throw new Error(s.error || "Diagnosis failed");
    if (Date.now() - started > timeoutMs)
      throw new Error("Diagnosis timed out");
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}

export async function toggleAction(idea_id, action_id) {
  const { data } = await api.post(
    `/ideas/${idea_id}/actions/${action_id}/toggle`,
  );
  return data;
}

export async function createCheckin(idea_id, payload) {
  const { data } = await api.post(`/ideas/${idea_id}/checkins`, payload);
  return data;
}

export async function listCheckins(idea_id, params = {}) {
  const { data } = await api.get(`/ideas/${idea_id}/checkins`, { params });
  return data;
}

export async function updateCheckin(idea_id, checkin_id, payload) {
  const { data } = await api.patch(
    `/ideas/${idea_id}/checkins/${checkin_id}`,
    payload,
  );
  return data;
}

export async function deleteIdea(idea_id) {
  const { data } = await api.delete(`/ideas/${idea_id}`);
  return data;
}

export async function createShareLink(diagnosis_id) {
  const { data } = await api.post(`/diagnoses/${diagnosis_id}/share`);
  return data;
}

export async function revokeShareLink(diagnosis_id) {
  const { data } = await api.delete(`/diagnoses/${diagnosis_id}/share`);
  return data;
}

export async function getSharedDiagnosis(slug) {
  // Public — don't send credentials
  const { data } = await api.get(`/share/${slug}`, { withCredentials: false });
  return data;
}
